// extracted by mini-css-extract-plugin
module.exports = {"container":"container___1Hv6b","FForbid":"FForbid___3nt_I","content":"content___eRre9"};